/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Elemente',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Aktualisiert',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Neu',
  'company-hub.hub-element-placeholder.extension.sub-heading':
    'Hier gibt es noch nichts zu sehen. Ihre Möglichkeiten sind vielfältig …',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Alle Optionen anzeigen',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Platzhalter für Hub-Elemente',
};
